import { render, staticRenderFns } from "./index.m.vue?vue&type=template&id=2721df7f&scoped=true"
import script from "./index.m.vue?vue&type=script&lang=js"
export * from "./index.m.vue?vue&type=script&lang=js"
import style0 from "./index.m.vue?vue&type=style&index=0&id=2721df7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721df7f",
  null
  
)

export default component.exports